import * as React from 'react';
import {Grid, Typography, List, ListItem, ListItemButton} from "@mui/material";
import {BasicWordWithId, BasicWordWithIdList} from "../../../common/types/words";
import DashboardPanel from "./DashboardPanel";
import WordInfoView from "../../vocabulary/components/WordInfoView/WordInfoView";

export interface WordListProps {
    title: string
    words: BasicWordWithIdList
    ready: boolean
}

export default function WordListSimpleView({title, words, ready} : WordListProps) {

    const [selectedWord, setSelectedWord] = React.useState<BasicWordWithId | null>(null);

    return (
        <DashboardPanel title={title} ready={ready} skeletonHeight={300}>
            <List sx={{py: 0}}>
                {words.map((word, index) => (
                    <ListItem key={index} disablePadding sx={{backgroundColor: 'primary.light'}}>
                        <ListItemButton onClick={() => setSelectedWord(word)}>
                            <Grid container>
                                <Grid item xs={6}>
                                    <Typography noWrap>{word.lemma}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography noWrap>{word.translation}</Typography>
                                </Grid>
                            </Grid>
                        </ListItemButton>
                    </ListItem>
                ))}
                {words.length === 0 && (
                    <ListItem sx={{backgroundColor: 'primary.light'}}>
                        No items
                    </ListItem>
                )}
            </List>
            {selectedWord && (
                <WordInfoView
                    word={selectedWord}
                    onDrawerClosed={() => setSelectedWord(null)}
                />
            )}
        </DashboardPanel>
    )

}
